module.exports = __webpack_public_path__ + "static/img/toux.ee2e93e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toux.png
// module id = /1rS
// module chunks = 3